import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { IconButton } from 'react-toolbox/lib/button'
import style from './styles.scss'

const CollapseIconButton = ({ collapse, onClick }) => {
  return (
    <IconButton 
      icon={collapse ? 'expand_more' : 'expand_less'}
      theme={style}
      onClick={onClick}
    />
  )
}

CollapseIconButton.propTypes = {
  onClick: PropTypes.func,
  collapse: PropTypes.bool.isRequired
}

export default CollapseIconButton
